export default "__VITE_ASSET__635f2903__"